import React from "react";
import { Button, Modal } from "react-bootstrap";
import YoutubeEmbed from "../YoutubeEmbed";

const HelpModal = ({
  show,
  changeModal,
}: {
  show: boolean;
  changeModal: (arg0: boolean) => void;
}) => {
  const handleClose = () => {
    if (!window.localStorage.getItem("firstEntry")) {
      window.localStorage.setItem("firstEntry", "false");
    }
    changeModal(false);
  };

  return show ? (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      style={{zIndex: 1000000}}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Ajuda</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5 className="pb-3">
          Este vídeo contém um tutorial sobre a utilização da Torre Logística de
          Entregas Comprovei! Tenha uma ótima utilização!
        </h5>
        <YoutubeEmbed embedId="IKB4lXyyaS4" />
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="primary" onClick={handleClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  ) : (
    <></>
  );
};

export default HelpModal;
